import _ from 'lodash';
import { nanoid } from 'nanoid';
import { generateBlobPdf } from 'components/pdf/download';
import { API, Storage } from 'aws-amplify';

export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const bytesToSize = (bytes, suffix, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  let i;
  if (suffix) i = sizes.findIndex(suff => suff === suffix);
  else i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const toBase64 = file => new Promise((resolve, reject) => {
  // eslint-disable-next-line no-undef
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export function getIngredientDetails(recipe, specificationId) {
  let details = {};
  let ingredients = {};
  let specificationToDetail = {};
  if (typeof specificationId === 'object') {
    specificationToDetail.details = specificationId;
  } else {
    specificationToDetail = recipe?.data?.getFormula?.requirements?.items.find(
      specification => specification.id === specificationId
    );
  }
  if (_.isEmpty(specificationToDetail)) return false;
  details = typeof specificationToDetail?.details === 'string' ? JSON.parse(specificationToDetail?.details) : specificationToDetail?.details;
  const name = specificationToDetail?.name;
  if (recipe?.data) {
    ingredients = JSON.parse(recipe?.data?.getFormula?.ingredients) || {};
  } else {
    ingredients = IsJsonString(recipe?.ingredients) ? JSON.parse(recipe?.ingredients) : recipe?.ingredients || {};
  }
  return {
    specificationToDetail, details, ingredients, name
  };
}

export async function sendSpecification(recipe, specificationId, result, products = []) {
  let sent = false;
  try {
    const { specificationToDetail, details, ingredients } = getIngredientDetails(recipe, specificationId);
    if (_.isEmpty(specificationToDetail)) return false;
    const pdf = await generateBlobPdf(ingredients, details, products);
    const pdfId = nanoid();
    const res = await Storage.put(`cahier-des-charges${pdfId}.pdf`, pdf);
    const url = await Storage.get(res.key, { expires: 604800 });
    const data = {
      name: result?.user?.name,
      email: result?.user?.email,
      phone: result?.user?.phone ?? '',
      message: result?.user?.message ?? '',
      file: url
    };
    await API.post('emailing', '/send-specification', { body: data });
    sent = true;
  } catch (e) {
    console.error(e);
  }
  return sent;
}
